module.exports = __webpack_public_path__ + "static/logo_transparent_xs-055f68832271390ccc9a9a3cb2272dbc.png";